<template>
  <section class="trainflow-section" aria-labelledby="trainflow-title">
    <div class="trainflow-inner">

      <h2 id="trainflow-title" class="section-title">TrainFlow</h2>

      <p class="paragraph">Stiamo sviluppando TrainFlow, una piattaforma che genera automaticamente programmi di allenamento personalizzati per gruppi e squadre. A partire da pochi input — sport, tempo, obiettivi, livello, attrezzatura — il motore di raccomandazione propone circuiti pronti all'uso, che si adattano nel tempo grazie ai feedback degli atleti.</p>

      <div class="part-2">
        <p class="part-2-text">TrainFlow è in fase di sviluppo. Se vuoi restare aggiornato o se vuoi essere tra i primi a testarlo, contattaci a <a href="mailto:info@sportemocracy.it" class="mail-link">info@sportemocracy.it</a>.</p>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'TrainFlowSection'
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.trainflow-section {
  background-color: $white;
  color: $black;
  width: 100%;
}

.trainflow-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.section-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

.paragraph {
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.7;
}

.part-2 {
  border: 1px solid $black;
  border-radius: 25px;
  padding: 32px 24px;
}

.part-2-text {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.7;
}

.mail-link {
  color: inherit;
  text-decoration: underline;
}

.mail-link:hover {
  opacity: 0.7;
}

@media (min-width: 768px) {
  .trainflow-inner {
    padding: 64px 40px;
  }
}

@media (min-width: 1440px) {
  .trainflow-inner {
    padding: 80px 120px;
  }

  .section-title {
    font-size: 2.4rem;
  }

  .part-2 {
    padding: 40px 48px;
  }
}
</style>
